import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=c686e5c2&"
import script from "./PurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./PurchaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports